import axios from 'axios'

// var callback;

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

var httpupload = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: {'Content-Type': 'multipart/form-data'},
  })

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}


//paket mapel

function addContent (dataBody, callback)
{
  var config = getConfig()

  http.post('/lms/detail', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getListVideo(id, callback) 
{
    var config = getConfig()
    http.get('/itembank/videos?mapel_id='+ id.mapel_id +'&grade_id=' + id.grade, config).then(function(response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function(error) {
      callback({
        success: true,
        message: error.message
      })
    })
}

function deleteContent (id, callback)
{
  var config = getConfig()
  http.delete('/lms/detail/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}


function editBab(dataBody, callback)
{
  var config = getConfig()

  http.put('/lms/section/'+ dataBody[1], dataBody[0], config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function updateContent(dataBody, callback)
{
  var config = getConfig()

  http.put('/lms/detail/'+ dataBody.id, dataBody.body, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function uploadFile(dataBody, callback)
{
  var config = getConfig()

  httpupload.post('/lms/upload', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getBabSubbab (id, callback)
{
  var config = getConfig()
  http.get('/itembank/topics?mapel_code=' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function getOneContent(id, callback) {
  var config = getConfig()
  http.get('/lms/detail/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

export default
{
  getListVideo,
  addContent,
  deleteContent,
  getBabSubbab,
  editBab,
  uploadFile,
  getOneContent,
  updateContent
}



// WEBPACK FOOTER //
// ./src/services/bimbel_materi.js